var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoor3DobjectHanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m37.273,31.243H4.727c-1.819,0-2.389-2.458-.756-3.259l17.029-8.35,17.029,8.35c1.633.801,1.063,3.259-.756,3.259Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m24.046,13.803c0-1.946-1.825-3.466-3.857-2.941-1.026.265-1.865,1.104-2.13,2.13-.422,1.632.476,3.131,1.854,3.658.65.248,1.087.858,1.087,1.554v1.43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoor3DobjectHanger);
export default __webpack_public_path__ + "static/media/indoor-3dobject_hanger.ada42f4c5f24f5cf2ce78bb837ef3ad7.svg";
export { ForwardRef as ReactComponent };